import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizePortTypes } from './normalize';

export const fetchPortTypes = createProvider(api.fetchPortTypes)
  .andThen((res) => normalizePortTypes(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
